import { render } from "./HeadNote.vue?vue&type=template&id=1a82d5f3"
import script from "./HeadNote.vue?vue&type=script&lang=js"
export * from "./HeadNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__